import { Stack } from "@mui/material";

import { useMemo, useState } from "react";

import { patch } from "../../apiClient";

import AudienceFloorProductSetting from "./components/AudienceFloorProductSetting";
import AudiencePricePerTimeOnSiteTable from "./components/AudiencePricePerTimeOnSiteTable";

const DEFAULT_TIME_ON_SITES = {
  10: null,
  15: null,
  20: null,
  30: null,
  40: null,
  60: null,
};

const DEFAULT_BASE_FLOOR_TIME_ON_SITES = {
  15: null,
  30: null,
};

const action = async ({ request, params }) => {
  const formData = await request.formData();
  const fields = Object.fromEntries(formData);

  if (fields.floor_type === "base") {
    return patch(
      "managed_plus",
      `/pricing/account_audience_floors/${params.accountId}`,
      {
        floor_type: "base",
        product_type: fields.product_type,
        rate_15: fields.rate_15 ?? "",
        rate_30: fields.rate_30 ?? "",
      }
    );
  }

  const payload = {
    ...fields,
    base_rate: formData.get("base_rate") && Number(formData.get("base_rate")),
  };

  return patch(
    "managed_plus",
    `/pricing/account_audience_floors/${params.accountId}`,
    payload
  );
};

const AccountTimeOnSiteForm = () => {
  const [state, setState] = useState({});
  const [editMode, setEditMode] = useState(false);

  const data = useMemo(() => {
    const isBaseFloor = state.query?.floor_type === "base";

    return {
      audience_floors: isBaseFloor
        ? state.data ?? DEFAULT_BASE_FLOOR_TIME_ON_SITES
        : state.data?.audience_floors || DEFAULT_TIME_ON_SITES,
      data_revenue_share: isBaseFloor
        ? undefined
        : state.data?.data_revenue_share,
    };
  }, [state.data, state.query]);

  return (
    <Stack spacing={3}>
      <AudienceFloorProductSetting
        onChange={(values) => setState(values)}
        onClear={(values) => {
          setEditMode(false);
          setState(values);
        }}
        disableClear={editMode}
      />
      <AudiencePricePerTimeOnSiteTable
        data={data}
        currentQuery={state.query}
        isEditing={!!state.editing}
        onEditModeChange={setEditMode}
      />
    </Stack>
  );
};

export { action };
export default AccountTimeOnSiteForm;
